
/* injects from baggage-loader */

import { CharThumbs } from '_appRoot/index.const';

export const introBallons = [
    'Esta é a ilha dos balões, o local onde as falas e os pensamentos das personagens tomam forma!',
    'É por meio dos balões que as palavras aparecem nos quadrinhos.',
    'A passagem de Albedo desorganizou as funções dos balões.'
]
export const tutorialBallons = [
    'Para derrotar o Albedo nesta fase, leia a página perdida e desvende os seus desafios.'
];

export const abeldoChallenge1Ballons = [
    'Eu desafio você a descobrir em qual dos balões a personagem parece estar gritando.'
]

export const abeldoChallenge2Ballons = [
    'Eu desafio você a descobrir qual quadro poderia substituir o original sem modificar o sentido.'
]

export const exercise1SuccessBallons = [
    'Muito bem! <br> Neste quadrinho, o pai de Liz parece estar gritando.',
    'Esse efeito é provocado pela expressão da personagem e pela formatação do texto em negrito.'
]

export const exercise1FailBallons = [
    'A voz dessa personagem não parece alterada... Observe novamente o quadrinho e tente outra vez.'
]

export const exercise2FailBallons = [
    'Observe novamente o quadrinho e tente outra vez.'
]

export const exercise2SuccessBallons = [
    '<div class="sentence-center-content">Muito bem! Em muitos quadrinhos, as palavras podem ser dispostas em balões de diferentes formatos e em recordatórios.</div>',
    `
        <div class="sentence-center-content">
            <div class="container-fluid" style="width: 100%;">
                <div class="row row middle-xs">
                    <div class="col-xs-12">
                        <img src="${require("_images/stages/stage-two/exercise-2/ballon-02.png")}" class="img-responsive" />
                    </div>
                    <div class="col-xs-12">
                        Os pensamentos das personagens, em geral, são representados por balões semelhantes a uma nuvem.
                    </div>
                </div>
            </div>
        </div>
    `,
    `
        <div class="sentence-center-content">
            <div class="container-fluid" style="width: 100%;">
                <div class="row row middle-xs">
                    <div class="col-xs-12">
                        <img src="${require("_images/stages/stage-two/exercise-2/ballon-01.png")}" class="img-responsive" />
                    </div>
                    <div class="col-xs-12">
                        Os balões formados por linhas retas indicam uma elevação da voz, um grito.
                    </div>
                </div>
            </div>
        </div>    
    `,
    `
        <div class="sentence-center-content">
            <div class="container-fluid" style="width: 100%;">
                <div class="row middle-xs">
                    <div class="col-xs-12">
                        <img src="${require("_images/stages/stage-two/exercise-2/ballon-03.png")}" class="img-responsive" />
                    </div>
                    <div class="col-xs-12">
                        Os recordatórios são caixas de texto usadas para recordar fatos, indicar uma fala do narrador etc.
                    </div>
                </div>
            </div>
        </div>
    `
]

export const scene1 = [
    {
        bg: require('_images/stages/stage-two/croma-abeldo-dialogs/scene-1.png'),
        text: ['Encontrei você, Albedo!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-two/croma-abeldo-dialogs/scene-2.png'),
        text: ['Ahhhhhhhh!!!'],
        thumb: CharThumbs.abeldo,
        visible: false
    },
];

export const scene2 = [
    {
        bg: require('_images/stages/stage-two/croma-abeldo-dialogs/scene-3.png'),
        text: ['Consegui recuperar uma das <b>páginas</b>!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-two/croma-abeldo-dialogs/scene-4.png'),
        text: ['Oh, não! Albedo <b>escapou</b> para outro esconderijo!<br> Vamos <b>Continuar</b>!'],
        thumb: CharThumbs.croma,
        visible: false
    },
];

export const exercise1 = [
    {
        value: 1,
        image: {
            default: require('_images/stages/stage-two/exercise-1/01.png'),
            active: require('_images/stages/stage-two/exercise-1/01-active.png'),
        }
    },
    {
        value: 2,
        image: {
            default: require('_images/stages/stage-two/exercise-1/02.png'),
            active: require('_images/stages/stage-two/exercise-1/02-active.png'),
        }
    },
    {
        value: 3,
        image: {
            default: require('_images/stages/stage-two/exercise-1/03.png'),
            active: require('_images/stages/stage-two/exercise-1/03-active.png'),
        }
    },
    {
        value: 4,
        image: {
            default: require('_images/stages/stage-two/exercise-1/04.png'),
            active: require('_images/stages/stage-two/exercise-1/04-active.png'),
        }
    },
    {
        value: 5,
        image: {
            default: require('_images/stages/stage-two/exercise-1/05.png'),
            active: require('_images/stages/stage-two/exercise-1/05-active.png'),
        }
    }
];

export const exercise2 = [
    {
        value: 1,
        image: {
            default: require('_images/stages/stage-two/exercise-2/01.png'),
            active: require('_images/stages/stage-two/exercise-2/01-active.png'),
        }
    },
    {
        value: 2,
        image: {
            default: require('_images/stages/stage-two/exercise-2/02.png'),
            active: require('_images/stages/stage-two/exercise-2/02-active.png'),
        }
    },
    {
        value: 3,
        image: {
            default: require('_images/stages/stage-two/exercise-2/03.png'),
            active: require('_images/stages/stage-two/exercise-2/03-active.png'),
        }
    }
];

export const exercise2Sample = require('_images/stages/stage-two/exercise-1/03.png');


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.const.js